module.exports = __webpack_public_path__ + "img/people-1-min.161f6dce.png";